import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default {
    name: "Customer",
    state: {
        customers: [],
        debtors: [],
        inactiveAccounts: [],
        customer: {},
        currentCustomer: {},
    },
    getters: {
        getCustomer: (state) => state.customer,
        getCustomers: (state) => state.customers,
        getInactiveAccounts: (state) => state.inactiveAccounts,
        getAllDebtors: (state) => state.debtors.sort(((a, b) => a.Debtor_Name.localeCompare(b.Debtor_Name))),
        getCurrentCustomer: (state) => state.currentCustomer,
        getDebtorByID: (state) => (id) => {
            id = Number(id)
            if (id === 0) {
                return 'None';
            }
            let debtor = state.debtors.find(customer => customer.Customer_id === id);
            return debtor ? debtor.Debtor_Name : id;
        }
    },
    mutations: {
        setCustomer: (state, payload) => state.customer = payload,
        setCustomers: (state, payload) => state.customers = payload,
        setInactiveAccounts: (state, payload) => state.inactiveAccounts = payload,
        setDebtors: async (state, data) => state.debtors = data,
        setCurrentCustomer: (state, data) => state.currentCustomer = data,
    },
    actions: {
        getAllCustomer: (context )=>{
            const from = context.rootGetters.getGlobalDateRange.From;
            const to = context.rootGetters.getGlobalDateRange.To;

            console.log(from,to)

            return axios.get(`${overflowSupApi}customers`, {
                params: {
                    from: from,
                    to: to,
                }
            })
                .then(({data})=> context.commit(`setCustomers`, data))
                .catch(err=>errorHandler.tomcatError(err))
        },
        getCustomer: (context , payload)=>{
            return axios.get(`${overflowSupApi}customers/getByID/${payload}`)
                .then(({data})=>context.commit(`setCustomer`, data))
                .catch(err=>errorHandler.tomcatError(err))
        },
        getAllDebtors: (context) => {
            return axios.get(ticketApi + `reg/Customer/search?search=`)
                .then(({data}) => context.commit('setDebtors', data))
                .catch(err=>errorHandler.tomcatError(err))
        },
        getAllStores:(context , customerID)=>{
            return axios.get(ticketApi+`customer/v2/getStores/${customerID}`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },
        getInactiveAccounts: (context) => {
            return axios.get(`${overflowSupApi}customers/inactive`)
                .then(({ data }) => {
                    const from = context.rootGetters.getGlobalDateRange.From;
                    const to = context.rootGetters.getGlobalDateRange.To;

                    if (!from || !to) {
                        context.commit(`setInactiveAccounts`, data);
                        return;
                    }

                    const start = new Date(from);
                    const end = new Date(to);

                    const filteredData = data.filter(account => {
                        if (!account.lastTransactionDate) return true;
                        const transactionDate = new Date(account.lastTransactionDate);
                        return transactionDate >= start && transactionDate <= end;
                    });

                    context.commit(`setInactiveAccounts`, filteredData);
                })
                .catch(err => errorHandler.tomcatError(err));
        },
        getStoresByCustomer: (context, id) => {
            if (!id) {
                return context.commit('setCurrentCustomer', {})
            }
            return axios.get(ticketApi + `reg/Customer/` + id)
                .then(({data}) => {
                    for (let i = 0; i < data.stores.length; i++) {
                        let storeID = data.stores[i].id;
                        let storeTickets = data.activeTickets.filter(ticket => ticket.store === storeID);
                        data.stores[i].tickets = [...storeTickets];
                    }
                    context.commit('setCurrentCustomer', data)
                }).catch(err=>errorHandler.tomcatError(err))
        },

        getCustomerInfo:(context , customerID)=>{
            return axios.get(ticketApi+`customer/v2/getInfo/${customerID}`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },
        getCustomerTickets:(context , data)=>{
            const {customerID, status } = data;
            console.log(customerID);
            return axios.get(ticketApi+`ticket/v2/getByCustomer/${customerID}?closed=${status}`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        deleteCustomer: (context, customerID)=>{
            console.log(customerID)
          // return axios.delete(overflowSupApi + `users/deleted/${customerID}`).then(() => {console.log("done")})
        },

        updateCustomer: (context, payload)=>{
            console.log(payload)
            // return axios.delete(overflowSupApi + `users/deleted/${customerID}`).then(() => {console.log("done")})
        },

        getClientRegistration(context, payload) {
            return axios.get(franchiseTomcatApi+`stores/getRegistrationDetails?database=${payload}`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        verifyTpin(context, payload) {
            return axios.get(franchiseTomcatApi+`/AndroidLogin/TPIN/${payload}`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        getLogo(context, payload) {
            return axios.get(franchiseSpringServerApi+`settings/${payload}/getLogo`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        getPaymentTypes(context, payload) {
            return axios.get(franchiseTomcatApi+`payment_options/${payload}/getAll`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        setLogo(context, payload) {

            const db = payload.database;
            const file = {
                file: payload.file,
            }
            return axios.post(franchiseSpringServerApi+`settings/${db}/addLogo`, file, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }})
                .then(({data})=>data)
                .catch(err=>errorHandler.tomcatError(err))
        },

        online(context, payload) {
            return axios.get(franchiseTomcatApi+`settings/${payload}/Online`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        getClientEmails(context, payload) {
            return axios.get(franchiseTomcatApi+`emailrecord/${payload}/getAllEmailAddresses`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        addEmail(context, payload) {
            return axios.post(franchiseTomcatApi+`emailrecord/${payload.DB}/addEmailToStore`, payload)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        deleteEmail(context, payload) {
            return axios.delete(franchiseTomcatApi+`emailrecord/${payload.database}/removeEmailFromStore?email=${payload.email}&DB=${payload.database}`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        getEmailSettings(context, payload) {
            return axios.get(franchiseTomcatApi+`emailrecord/${payload}/getEmailSettings`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        setEmailSettings(context, payload) {
            return axios.post(franchiseTomcatApi+`emailrecord/${payload.database}/setEmailSettings`, payload.settings)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        updateClient(context, payload) {
            return axios.post(franchiseSpringServerApi+`settings/${payload.database}/saveBasicSettings`, payload)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        checkSmartInvoicing(context, payload) {
            return axios.get(franchiseTomcatApi+`GRV/${payload}/checkSmartInvoicing`)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        resetKazangPassword(context, payload){
            const data = {
                username: payload,
            };
            return axios.post(franchiseTomcatApi+`SetKazangUser/${payload}/forgotPasswordRequest`, data)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        changeKazangPassword(context, payload){
            return axios.post(franchiseTomcatApi+`SetKazangUser/${payload.username}/resetPassword`, payload)
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },

        getStoreByID: (context, id) => {
            return axios.get(ticketApi + `reg/store/` + id)
                .then(({data}) => context.commit('setCurrentStore', data))
                .catch(err=>errorHandler.tomcatError(err))
        },

        getOnlineInvoicing: (context, id) => {
            return axios.get(subscriptionApi + `customerUpdate/getOnlineInvoicing/` + id)
                .then(({data}) => data).catch(err=>errorHandler.tomcatError(err))
        },

        setOnlineInvoicing:async (context, payload) => {
            let user = await Storage.getCurrentUser();
            payload.user = user.Username;
            return axios.put(subscriptionApi + `customerUpdate/updateOnlineInvoicing`, payload)
                .catch(err=>errorHandler.tomcatError(err))
        },

        getStoreKazangDetails: (context, storeDB) => {
            return axios.get(subscriptionApi + `customerUpdate/getKazangDetails/${storeDB}`)
                .then(({data}) => data).catch(err=>errorHandler.tomcatError(err))
        },

        updateStoreKazangDetails: (context, payload) => {
            return axios.post(franchiseTomcatApi + `SetKazangUser/${payload.storeDB}`,payload)
                .then(({data}) => data).catch(err=>errorHandler.tomcatError(err))
        },

        getTicketsStoreID: (context, id) => {
            return axios.get(ticketApi + `ticket/store/` + id)
                .then(({data}) => data).catch(err=>errorHandler.tomcatError(err))
        },

        addStoreToCustomer: (context, payload) => {
            let customerID = payload.mainCustomer;
            let url  = subscriptionApi + `customerUpdate/addStore/${customerID}`;
            return context.dispatch(`sendRequest`,{url , payload })
                .then((data) => {
                    context.dispatch('getStoresByCustomer', customerID)
                    return data;
                }).catch(err=>errorHandler.tomcatError(err))
        },

        sendKazangSignUpDetails : (context,payload) => {
            return axios.post(`https://chrilantech.com/LytSoftPosOnline/api/email/sendKazangSignUp`,payload,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
    }
}
